<template>
  <div class="addressList">
    <div class="navBar-wrap">
      <div class="select-navBar">
        <div class="arrow" @click="goBack"><van-icon name="arrow-left" /></div>
        <p class="title">{{ user.companyName }}</p>
      </div>
    </div>
    <div class="addressList-nav">
      <div class="searchBox" @click="toSearch">
        <img src="@/assets/images/search_big.png" alt="" />
        <p>{{ $t('请输入搜索关键字') }}</p>
      </div>
      <div class="menu-box">
        <div @click="toIndex">{{ $t('组织成员') }}</div>
        <ul class="child-menu">
          <li
            v-for="(item, idx) in navList"
            :key="item.departmentId"
            :style="{
              color: idx + 1 == navList.length ? '#333333' : '#009BFF',
            }"
            @click="toMenu(item, idx)"
          >
            <img src="@/assets/images/pull.png" alt="" />
            <p>{{ item.departmentName }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="addressList-card" :style="{ maxHeight: addressHeight }">
      <van-checkbox-group
        v-model="indexResult"
        ref="departments"
        v-show="showAddressList"
      >
        <van-cell-group>
          <van-cell
            v-for="item in currentInfo"
            clickable
            :key="item.departmentId"
          >
            <template #title>
              {{ item.departmentName }}
              <span :style="{ color: '#999999' }">
                ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
              >
            </template>
            <template #right-icon>
              <div
                @click="toChild(item)"
                class="contact-card"
                v-show="item.totalStaffCount != 0"
              >
                <div></div>
                <img
                  :src="
                    item.selectNum > 0
                      ? require('@/assets/images/inferior_actived.png')
                      : require('@/assets/images/inferior.png')
                  "
                  alt=""
                />
                <span
                  :style="{
                    opacity: item.selectNum > 0 ? 0.5 : 1,
                    color: '#009BFF',
                  }"
                  >{{ $t('下级') }}</span
                >
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div v-show="!showAddressList">
        <van-checkbox-group v-model="result" ref="childDepartments">
          <van-cell-group>
            <van-cell
              v-for="item in currentInfo.children"
              clickable
              :key="item.departmentId"
            >
              <template #title>
                {{ item.departmentName }}
                <span :style="{ color: '#999999' }">
                  ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                  }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
                >
              </template>
              <template #right-icon>
                <div
                  @click="toChild(item)"
                  class="contact-card"
                  v-show="item.totalStaffCount != 0"
                >
                  <div></div>
                  <img
                    :src="
                      item.selectNum > 0
                        ? require('@/assets/images/inferior_actived.png')
                        : require('@/assets/images/inferior.png')
                    "
                    alt=""
                  />
                  <span
                    :style="{
                      opacity: item.selectNum > 0 ? 0.5 : 1,
                      color: '#009BFF',
                    }"
                    >{{ $t('下级') }}</span
                  >
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-checkbox-group
          v-model="staffResult"
          ref="staffs"
          :style="{ marginTop: '12px' }"
        >
          <van-cell-group>
            <van-cell
              v-for="item in currentInfo.staffs"
              clickable
              :key="item.departmentId"
            >
              <template #title>
                <van-checkbox
                  :name="item.staffId"
                  @click="changeStaff(item.staffId)"
                >
                  <div class="staffs-card">
                    <img
                      :src="
                        item.faceUrl ||
                        require('@/assets/images/default_avatar.png')
                      "
                      alt=""
                    />
                    <div>
                      <div class="staffs-card-name">{{ item.staffName }}</div>
                      <div class="staffs-card-job">{{ item.jobPost }}</div>
                    </div>
                  </div>
                </van-checkbox>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    <div class="agreeBox" :style="{ position: 'fixed', bottom: 0 }">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="agree-btn"
        @click="onConfirm"
        >{{ $t('确定') }}</van-button
      >
    </div>
    <van-popup v-model="showSearch" class="search-model">
      <div class="search-navBar">
        <div class="left-icon" @click="leaveSearch">
          <van-icon name="arrow-left" />
        </div>
        <div class="searchBox">
          <van-field
            v-model="searchName"
            :placeholder="$t('请输入搜索关键字')"
            :left-icon="require('@/assets/images/search.png')"
            class="search-name"
            clearable
            @input="selectStaff"
          />
        </div>
      </div>
      <van-checkbox-group v-model="staffResult" class="search-list">
        <van-cell-group>
          <van-cell
            v-for="item in searchList"
            clickable
            :key="item.staffId + ':' + item.departmentId"
          >
            <template #title>
              <van-checkbox :name="item.id" @click="changeStaff(item.id)">
                <div class="staffs-card">
                  <img
                    :src="
                      item.faceUrl ||
                      require('@/assets/images/default_avatar.png')
                    "
                    alt=""
                  />
                  <div>
                    <div class="staffs-card-name">{{ item.name }}</div>
                    <div class="staffs-card-job">{{ item.jobPost }}</div>
                  </div>
                </div>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="agreeBox" :style="{ position: 'absolute' }">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="agree-btn"
          @click="onConfirm"
          >{{ $t('确定') }}</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { isMobileType } from '@/utils/isMobileType.js'
import {
  Checkbox,
  CheckboxGroup,
  Button,
  Cell,
  CellGroup,
  Field,
  Radio,
  RadioGroup,
  Card,
  Popup,
} from 'vant'
import { getstaffByDepartment } from '@/services/api'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Popup)
export default {
  name: 'Address',
  props: ['userList', 'selectedList'],
  components: {},
  data() {
    return {
      indexResult: [],
      result: [],
      staffResult: [],
      user: {},
      showAddressList: true,
      currentStaffList: [],
      searchName: null,
      searchList: [],
      selAll: [],
      currentdepartmentList: [],
      staffIdList: [],
      departmentList: [],
      displayList: [],
      totalInfo: [],
      currentInfo: [],
      showSelected: false,
      showSearch: false,
      navList: [],
      addressHeight: null,
    }
  },
  methods: {
    checkDepartmentChild(data, item) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((childStaffs) => {
              item.id == childStaffs.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(childItem, item)
        })
      } else return
    },
    delDepartmentChild(data, arr) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((item) => arr.push(item.staffId))
          arr = this.delDepartmentChild(childItem, arr)
        })
        return arr
      } else return arr
    },
    ifSelected(id) {
      return this.staffIdList.some((item) => item.id == id)
    },
    changeIndexDepartmentId(data) {
      if (this.indexResult.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              item.id == item1.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(data, item)
        })
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => arr.push(item.staffId))
        arr = this.delDepartmentChild(data, arr)
        this.staffIdList = this.staffIdList.filter(
          (item) => !arr.includes(item.id)
        )
      }
    },
    changeDepartmentId(data) {
      if (this.result.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              item.id == item1.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(data, item)
        })
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => arr.push(item.staffId))
        arr = this.delDepartmentChild(data, arr)
        this.staffIdList = this.staffIdList.filter(
          (item) => !arr.includes(item.id)
        )
      }
    },

    changeStaff(id) {
      this.staffResult = [id]
      this.userList.forEach((item) => {
        if (item.id == id) {
          this.staffIdList = [item]
        }
      })
    },
    leaveSearch() {
      if (this.currentInfo == this.totalInfo) {
        this.currentInfo.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item, true)
        })
      } else {
        if (this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((item) => {
            item.selectNum = this.checkIfChildDepartmentSelected(item)
          })
        }
      }
      this.searchName = ''
      this.showSearch = false
    },
    async getDepartment(companyId) {
      const res = await getstaffByDepartment({ companyId })
      this.totalInfo = res
      this.currentInfo = res
      this.init()
    },
    checkIfChildDepartmentSelected(data, ifIndex) {
      let checkNum = (departmentData) => {
        if (
          departmentData.children.length > 0 ||
          (departmentData.staffs && departmentData.staffs.length > 0)
        ) {
          let departmentNum = 0
          departmentData.children.length > 0 &&
            departmentData.children.forEach((item) => {
              if (!item.staffs || item.staffs.length == 0) return 0
              let totalNum = checkNum(item)
              departmentNum += totalNum
            })
          let staffsNum = 0
          departmentData.staffs &&
            departmentData.staffs.length > 0 &&
            departmentData.staffs.forEach((item) => {
              this.staffIdList.forEach((item1) => {
                item1.id == item.staffId && staffsNum++
              })
            })
          return departmentNum + staffsNum
        } else return 0
      }
      let selectNum = checkNum(data)
      data.totalStaffCount != 0 &&
        data.totalStaffCount == selectNum &&
        (ifIndex
          ? !this.indexResult.includes(data.departmentId) &&
            this.indexResult.push(data.departmentId)
          : !this.result.includes(data.departmentId) &&
            this.result.push(data.departmentId))
      if (data.totalStaffCount !== selectNum) {
        if (ifIndex) {
          this.indexResult.includes(data.departmentId) &&
            (this.indexResult = this.indexResult.filter(
              (item) => item != data.departmentId
            ))
        } else {
          if (this.result.includes(data.departmentId)) {
            this.result = this.result.filter(
              (item) => item != data.departmentId
            )
          }
        }
      }
      return selectNum
    },
    toChild(data) {
      this.result = []
      this.navList.push(data)
      this.showAddressList = false
      this.currentInfo = data
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
    },
    onConfirm() {
      this.$emit('confirm', this.staffIdList)
    },
    goBack() {
      this.$emit('back')
    },
    init() {
      if (this.selectedList.length < 1) return
      this.staffIdList = [...this.selectedList]
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
    },
    toIndex() {
      this.indexResult = []
      this.navList = []
      this.showAddressList = true
      this.currentInfo = this.totalInfo
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
    },
    toMenu(data, idx) {
      this.result = []
      this.currentInfo = data
      this.navList = this.navList.slice(0, idx + 1)
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
    },
    selectStaff(v) {
      this.searchList = []
      let arr = this.userList.filter((item) => {
        if (!item.name) return
        return item.name.includes(v)
      })
      this.searchList = arr
    },
    toSearch() {
      this.searchList = []
      this.showSearch = true
    },
    toDisplay() {
      this.showSelected = true
    },
    checkselectedDepartment(data, arr) {
      if (data.length > 0) {
        data.forEach((item) => {
          arr.push(item.departmentId)
          this.checkselectedDepartment(item.children, arr)
        })
      } else return
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            selectedData = this.checkTotalStaffCount(item.children, id)
          } else return
        }
      })
      return selectedData
    },
    fliterDepartment(data, arr) {
      data.forEach((item) => {
        item.staffs &&
          item.staffs.length > 0 &&
          item.staffs.forEach((staffItem) => arr.push(staffItem.staffId))
        item.children.length > 0 && this.fliterDepartment(item.children, arr)
      })
      return arr
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.staffIdList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    isWeixin() {
      if (
        window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        'micromessenger'
      ) {
        if (isMobileType.iOS()) {
          this.addressHeight =
            parseInt((370 / 812) * document.body.scrollHeight) + 'px'
        } else {
          this.addressHeight =
            parseInt((420 / 812) * document.body.scrollHeight) + 'px'
        }
      } else {
        this.addressHeight =
          parseInt((420 / 812) * document.body.scrollHeight) + 'px'
      }
    },
  },
  computed: {
    selectNum() {
      return this.staffIdList.length || 0
    },
    selectdepartmentNum() {
      if (this.staffIdList.length == 0) {
        return 0
      } else {
        let warpList = []
        let arr = Array.from(
          new Set(this.staffIdList.map((item) => item.departmentId))
        )
        this.totalInfo.forEach((item) => {
          let departmentList = []
          departmentList.push(item.departmentId)
          this.checkselectedDepartment(item.children, departmentList)
          arr.forEach((id) => {
            if (departmentList.includes(id)) warpList.push(item.departmentId)
          })
        })
        let num = Array.from(new Set(warpList)).length
        return num
      }
    },
  },
  watch: {
    selectdepartmentNum: {
      deep: true,
      handler: function () {
        if (
          this.staffIdList.length == 0 &&
          !this.displayList.department.length
        ) {
          return
        } else {
          let warpList = []
          let arr = Array.from(
            new Set(this.staffIdList.map((item) => item.departmentId))
          )
          this.totalInfo.forEach((item) => {
            let departmentList = []
            departmentList.push(item.departmentId)
            this.checkselectedDepartment(item.children, departmentList)
            arr.forEach((id) => {
              if (departmentList.includes(id)) warpList.push(item.departmentId)
            })
          })
          let selectedIdList = this.staffIdList.map((item) => item.id)
          let department = []
          arr.forEach((departmentId) => {
            let slectedNum = this.staffIdList.filter(
              (item) => item.departmentId == departmentId
            ).length
            let departmentInfo = this.checkTotalStaffCount(
              this.totalInfo,
              departmentId
            )
            if (
              departmentInfo.staffs &&
              slectedNum == departmentInfo.staffs.length
            ) {
              //判断是否最底层部门
              if (departmentInfo.children.length == 0) {
                let finalDepartment = this.checkSuperiorDepartment(
                  departmentInfo,
                  departmentId,
                  arr
                )
                finalDepartment &&
                  department.every(
                    (item) => item.departmentId != finalDepartment.departmentId
                  ) &&
                  department.push(finalDepartment)
              } else {
                let ifAllChildSelected = []
                departmentInfo.children.forEach((childItem) => {
                  let bl = this.checkSubordinateDepartment(
                    childItem,
                    selectedIdList
                  )
                  ifAllChildSelected.push(bl)
                })
                if (ifAllChildSelected.every((item) => item == true)) {
                  let finalDepartment = this.checkSuperiorDepartment(
                    departmentInfo,
                    departmentId,
                    arr
                  )
                  finalDepartment &&
                    department.every(
                      (item) =>
                        item.departmentId != finalDepartment.departmentId
                    ) &&
                    department.push(finalDepartment)
                } else return
              }
            }
          })
          let departmentIdList = Array.from(
            new Set(department.map((item) => item.departmentId))
          )
          department = department.filter((item) => {
            if (item.pid) {
              return !departmentIdList.includes(item.pid)
            } else return true
          })
          this.displayList.department = [...department]
          let staffInDepartment = []
          staffInDepartment = this.fliterDepartment(
            department,
            staffInDepartment
          )
          this.displayList.staff = this.staffIdList.filter(
            (item) => !staffInDepartment.includes(item.id)
          )
        }
      },
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  mounted() {
    this.isWeixin()
    this.getDepartment(this.user.companyId)
  },
}
</script>
<style lang="less" scoped>
.addressList {
  height: 100%;
  background-color: #f6f6f6;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  .addressList-nav {
    background-color: #ffffff;
    padding: 14px 18px;
    .searchBox {
      width: 344px;
      height: 30px;
      border-radius: 4px;
      margin-bottom: 12px;
      border: 1px solid #d9d9d9;
      font-size: 14px;
      display: flex;
      // justify-content: space-evenly;
      align-items: center;
      margin-right: 8px;
      color: #cccccc;
      background: #f1f1f1;
      img {
        width: 19px;
        height: 18px;
        margin-left: 15px;
        margin-right: 11px;
      }
    }
    .menu-box {
      display: flex;
      color: #009bff;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
      overflow: auto;
      .child-menu {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          padding-left: 8px;
          img {
            width: 16px;
            height: 17px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .addressList-all {
    height: 56px;
    background-color: #ffffff;
    padding-left: 16px;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 10px;
  }
  .addressList-card {
    flex: 1;
    overflow: auto;
    margin-bottom: 10px;
  }
  .staffs-card {
    display: flex;
    margin-left: 9px;
    img {
      width: 46px;
      height: 47px;
      margin-right: 10px;
    }
    .staffs-card-name {
      line-height: 24px;
    }
    .staffs-card-job {
      line-height: 24px;
      color: #999999;
    }
  }
  .agreeBox {
    width: 100%;
    background-color: #ffffff;
    bottom: 2px;
    left: 0;
    .select-info {
      padding-left: 16px;
      font-size: 14px;
      color: #009bff;
      margin-top: 17px;
      margin-bottom: 12px;
      line-height: 24px;
      img {
        margin-left: 16px;
        width: 18px;
        height: 12px;
      }
    }
    .agree-btn {
      border: none;
      width: 351px;
      margin: 0px auto 23px;
    }
  }
}
.navBar-wrap {
  width: 100%;
  background: #ffffff;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #ececec;
  font-size: 18px;
  position: relative;
  .arrow {
    height: 100%;
    padding: 3px 19px;
    position: absolute;
  }
  .title {
    font-size: 17px;
    font-weight: 500;
  }
  .selected-navBar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .left-icon {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
      left: 0px;
    }
  }
}
.contact-card {
  display: flex;
  img {
    width: 19px;
    height: 21px;
    margin: 0px 7px;
  }
  > div {
    width: 1px;
    height: 20px;
    background: #ededed;
  }
}
.search-model {
  height: 100%;
  width: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  .search-navBar {
    width: 100%;
    background: #ffffff;
    line-height: 40px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
    .left-icon {
      height: 100%;
      padding-top: 3px;
    }
    .searchBox {
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      width: 312px;
      .search-name {
        padding: 3px 15px;
      }
    }
  }
  .search-list {
    flex: 1;
    overflow: auto;
    padding-bottom: 122px;
  }
}
.display-wrap {
  background: #fefffe;
  padding: 0 16px;
  li {
    color: #333333;
    line-height: 24px;
    display: flex;
    height: 45px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    justify-content: space-between;
    img {
      width: 16px;
      height: 17px;
    }
  }
}
</style>
